module.exports = __webpack_public_path__ + "static/media/plan.3599edf0.png";